var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-container',{attrs:{"fluid":""}},[_c('div',[_c('detail-view',{attrs:{"item":_vm.selectedItem}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }